"use client";

import { useEffect } from "react";
import { useSearchParams } from "next/navigation";
import styles from "./home.module.css";

// /api/waitlist redirects back to /?waitlist=success|error|missing. Reading the
// flag on the client keeps the homepage static; the form itself works without JS.
// Short lines, set in the design's uppercase mono under the form.
const MESSAGES: Record<string, { text: string; tone: "ok" | "warn" }> = {
  success: { text: "Request received", tone: "ok" },
  error: { text: "Something went wrong. Try again", tone: "warn" },
  missing: { text: "Fill in all four fields", tone: "warn" },
};

export default function AccessStatus() {
  const status = useSearchParams().get("waitlist");
  const message = status ? MESSAGES[status] : undefined;

  // The redirect lands at the top of the page; bring the visitor back to the form.
  useEffect(() => {
    if (message) document.getElementById("access")?.scrollIntoView({ block: "start" });
  }, [message]);

  // Always rendered, empty when there's nothing to say, so the line keeps its height.
  return (
    <span className={styles.done} role={message?.tone === "warn" ? "alert" : "status"}>
      {message?.text}
    </span>
  );
}
